import { render, staticRenderFns } from "./VaTreeCategory.vue?vue&type=template&id=e3e31ea4&"
import script from "./VaTreeCategory.vue?vue&type=script&lang=js&"
export * from "./VaTreeCategory.vue?vue&type=script&lang=js&"
import style0 from "./VaTreeCategory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports